import { Text } from './Text';
import { useSync } from '@/hooks/useSync';
import { usePos } from '@/store/pos';
import styles from './ConnectionBanner.module.css';

/**
 * Says so when the screens are not showing the shop's real numbers.
 *
 * The figures come from the server. When it cannot be reached they are the last
 * ones that arrived — or zeros, before the first ever did — and a shopkeeper
 * reading "ຂາຍມື້ນີ້ 0" with no explanation would reasonably conclude the app
 * had lost their day. Saying it plainly is the whole job of this strip.
 */
export function ConnectionBanner() {
  const { status } = useSync();
  const loaded = usePos((s) => s.loaded);

  // 'starting' is not a fault, and flashing a warning during a normal boot
  // would teach the shop to ignore this strip. 'unauthorised' never reaches
  // here either — the login screen replaces the whole app in that state.
  if (status !== 'offline') return null;

  return (
    <div className={styles.banner} aria-live="polite">
      <Text size={12} weight={700} align="center">
        {loaded
          ? 'ຕໍ່ອິນເຕີເນັດບໍ່ໄດ້ · ຕົວເລກອາດບໍ່ທັນສະໄໝ ແລະ ຍັງຂາຍບໍ່ໄດ້'
          : 'ຕໍ່ອິນເຕີເນັດບໍ່ໄດ້ · ຍັງໂຫຼດຂໍ້ມູນຮ້ານບໍ່ໄດ້'}
      </Text>
    </div>
  );
}
